<template>
    <page>
        <v-container fluid>
            <v-card elevation="10" class="mb-2">
                <v-card-title>Okta</v-card-title>
                <v-card-text>
                    <strong>Authenticated:</strong>
                    <br />
                    <p class="content">{{ authenticated }}</p>
                    <strong>ID Token:</strong>
                    <br />
                    <p class="content">{{ idToken }}</p>
                    <strong>Token:</strong>
                    <br />
                    <p class="content">{{ token }}</p>
                    <strong>User:</strong>
                    <br />
                    <p class="content">{{ user }}</p>
                    <strong>Groups:</strong>
                    <br />
                    <p class="content">{{ groups }}</p>
                </v-card-text>
            </v-card>
        </v-container>
    </page>
</template>

<script>
import Page from "@/components/layout/page.vue";
import axios from "axios";

// Deprecated
export default {
    name: "okta",
    components: { Page },
    data() {
        return {
            authenticated: null,
            token: null,
            idToken: null,
            user: null,
            groups: null,
        };
    },
    computed: {},
    async created() {
        setInterval(this.update, 5000);
        await this.update();
    },
    mounted() {},
    destroyed() {},
    methods: {
        async update() {
            this.authenticated = await this.$auth.isAuthenticated();
            this.token = await this.$auth.getAccessToken();
            this.user = await this.$auth.getUser();
            this.idToken = await this.$auth.getIdToken();

            this.groups = (
                await axios.get(`https://${process.env.VUE_APP_OKTA_DOMAIN}/api/v1/users/me/groups`, {
                    withCredentials: true,
                })
            ).data;
        },
    },
};
</script>
